import {getRequest, postRequest, putRequest} from "@/api/http";

// 获取图形验证码
export const getSmsCodeImg = (smsPhone) => getRequest("/smsAuth/sendAuthCode/" + smsPhone);

// 获取图形验证码
export const getCodeImg = () => getRequest("/captchaImage");
// 登录
export const loginAccount = (data) => postRequest("/login", data);
export const login = (data) => postRequest("/loginWithSmsCode", data);
export const updateUserPwd = (data) => putRequest("/system/user/profile/updatePwd", data);
// 用户密码重置
// 获取用户详细信息
export const getUserInfo = (data) => getRequest("/getInfo", data);

// 公共模块
export const getDicts = (dictType) => getRequest("/system/dict/data/type/" + dictType);// 根据字典类型查询字典数据信息


// 病例管理/订单管理
export const listMedicalOrder = (data) => getRequest("/buz/medicalOrder/listForAll", data); // 查询工单信息列表
export const getMedicalOrderDetail = (orderId) => getRequest("/buz/medicalOrder/detail/" + orderId); // 查询工单信息详细 包含所有信息
export const getPatientListByName = (searchKey) => getRequest("/buz/docPatientProfile/listAllNameList/"+ searchKey);
export const clinicSqbOrderPay = (data) => postRequest("/sqbOrderPay/create", data); // 收钱吧付款码收款

// 统计分析
export const getColumnData = (startTime,endTime,data) => getRequest("/buz/docStat/getColumnData/" + startTime+"/"+endTime, data);
export const getServerData = (startTime,endTime, data) => getRequest("/buz/docStat/getServerData/" + startTime+"/"+endTime, data);


// 查询检查治疗订单所有列表
export const getTreatOrderAllList = (data) => getRequest("/buz/treatOrder/listAll", data);
// 查询检查治疗订单列表_子列表
export const getTreatOrderItemList = (data) => getRequest("/buz/treatOrderItem/list", data);

// 执行检查治疗项目
export const executetreatOrderItem = (toId) => putRequest("/buz/treatOrderItem/executeItem/" + toId); // 查询常用处方详细

// 预约管理
export const getReservationList = (data) => getRequest("/buz/patientReservation/list", data);
export const getTodayReservationList = (data) => getRequest("/buz/patientReservation/list", data); // 今日预约查询
export const signReOrder = (reId) => putRequest("/buz/patientReservation/signReOrder/"+reId); // 签到
export const getTodayReservationStat = (data) => getRequest("/buz/patientReservation/todayReservationStat", data); // 今日预约统计

